module.exports = __webpack_public_path__ + "img/banner.6cd9ddf9.png";